export default function checkIfCanSeeQuestionnaireRoutes({ next, store }) {
  let scopes = store.getters.userScopes;
  let exists = scopes.includes('questionnaire_list');
  return exists ? next() : next({ name: 'dashboard' });
}
